import React from "react";
import { Link, useLocation } from "react-router-dom";
import { NavTitle, Icon, NavItem } from "../styled/MobileNav.styled";
import { withErrorBoundary } from "../boundaries/withErrorBoundary";
import GeneralErrorBoundary from "../boundaries/GeneralErrorBoundary";

const formatTitleForMobile = title => {
	const length = 8;
	if (title.length <= length) return title;
	return title.split("").splice(0, length).join("") + '...';
}

function MobileNavItem({ icon, title, path }) {
	let location = useLocation();
	const isActive = location.pathname.includes(path);
	return (
		<Link to={path} style={{ textDecoration: "none", color: "inherit" }}>
			<NavItem $active={isActive}>
				<Icon className={'fa-regular ' + icon} />
				<NavTitle $active={isActive}>{formatTitleForMobile(title)}</NavTitle>
			</NavItem>
		</Link>
	);
}

export default withErrorBoundary(MobileNavItem, GeneralErrorBoundary);
